import Glide, { Controls, Autoplay, Breakpoints, Swipe } from '@glidejs/glide/dist/glide.modular.esm'


/**
 * Image Gallery Flexi Block
 */
( () => {
    const blocks = document.querySelectorAll( '.block--gallery' )

    if ( !blocks ) {
        return
    }

    function initGallery( block ) {
        const glideEl = block.querySelector( '.glide' )
        const infiniteLoop = glideEl.dataset.infiniteLoop === 'true'

        const glide = new Glide( block.querySelector( '.glide' ), {
            type: 'carousel',
            autoplay: 10000,
            perView: 3,
            gap: 30,
            peek: 75,
            focusAt: 'center',
            breakpoints: {
                800: {
                    perView: 1,
                    gap: 20,
                    peek: 50
                }
            }
        })

        glide.mount({ Controls, Autoplay, Breakpoints })

        if ( !infiniteLoop ) {
            glide.on( 'move.after', () => {
                glideEl.querySelector( '.glide__arrow--left' ).disabled = glide.index === 0
                glideEl.querySelector( '.glide__arrow--right' ).disabled = glide.index === glideEl.querySelectorAll( '.glide__slide:not(.glide__slide--clone)' )?.length - 1
            })
        }
    }
    blocks.forEach( initGallery )
})();


/**
 *  Products
 */
 ( () => {

    var blocks = document.querySelectorAll('.glide--products');

    if( !blocks ) {
        return
    }

    function initGallery( block ) {
        const glide = new Glide( block, {
            type: 'carousel',
            autoplay: 10000,
            perView: 3,
            gap: 30,
            peek: {
                before: 150,
                after: 0,
            },
            breakpoints: {
                800: {
                    perView: 1,
                    gap: 20,
                    peek: 50
                }
            }
        });
        
        glide.mount({ Controls, Autoplay, Breakpoints })

    }
    blocks.forEach( initGallery )
    
})();

/**
 * Team Members
 */
 ( () => {
    const blocks = document.querySelectorAll( '.block--team-members' )

    if ( !blocks ) {
        return
    }

    function initGallery( block ) {
        const glide = new Glide( block.querySelector( '.glide--image' ), {
            type: 'carousel',
            autoplay: 6000,
            perView: 3,
            gap: 30,
            peek: {
                before: 0,
                after: -250
            },
            breakpoints: {
                1920: {
                    perView: 2
                },
                1024: {
                    perView: 1,
                    gap: 20,
                    peek: {
                        before: 0,
                        after: 0
                    }
                }
            }
        });
        const slave = new Glide( block.querySelector( '.glide--text' ), {
            type: 'carousel',
            perView: 1,
            gap: 0
        }).mount();

        // Normalise slide heights
        const slides = block.querySelector( '.glide--text' ).querySelectorAll( '.glide__slide' );
        const slideHeights = [];
    
        slides.forEach((slide) => slideHeights.push(slide.scrollHeight));
        slides.forEach((slide) => slide.style.minHeight = Math.max(...slideHeights) + 'px');

        glide.on("run", function () {
            slave.go(`=${glide.index}`);
        });
        
        glide.mount({ Controls, Autoplay, Breakpoints })

        block.addEventListener('mouseover', function () {
            glide.pause()
        })

        block.addEventListener('mouseout', function () {
            glide.play()
        })

    }
    blocks.forEach( initGallery )
})();

/**
 * Single Gallery
 * 
 * Display a modoal for images.
 */
 ;( () => {
    const modal = document.querySelector( '#image-modal' )
    let images = document.querySelectorAll( '.image-gallery a' )
    let isMounted = false

    if ( !images.length && !modal ) {
        return
    }

    const imageCarousel = new Glide( modal.querySelector( '.glide' ), {
        type: 'carousel',
        perView: 1
    })

    images.forEach( ( image, index ) => {
        image.addEventListener( 'click', event => {
            event.preventDefault()

            showGalleryModal()

            if ( !isMounted ) {
                imageCarousel.mount({ Controls, Swipe })
                isMounted = true
            }

            imageCarousel.go( `=${ index }` )
        })
    })

    modal.addEventListener( 'click', event => {
        event.preventDefault()

        if ( ![ 'IMG', 'BUTTON', 'svg' ].includes( event.target.tagName ) ) {
            hideGalleryModal()
        }
    })


    function showGalleryModal() {
        modal.classList.add( 'is-visible' )
        modal.setAttribute( 'aria-hidden', false )

        window.addEventListener( 'keyup', escHideModal )
    }

    function hideGalleryModal() {
        modal.classList.remove( 'is-visible' )
        modal.setAttribute( 'aria-hidden', true )

        window.removeEventListener( 'keyup', escHideModal )
    }

    /**
     * Hide the modal by pressing the escape key.
     * 
     * @param {KeyboardEvent} event 
     */
     function escHideModal( event ) {
        if ( event.key === 'Escape' ) {
            hideGalleryModal()
        }
    }
})();

/**
 * Testimonials
 * 
 */
;( () => {
    const blocks = document.querySelectorAll( '.block--testimonials' )

    if ( !blocks ) {
        return
    }

    function initGallery( block ) {
        const glide = new Glide( block.querySelector( '.glide' ), {
            type: 'carousel',
            autoplay: 8000,
            perView: 1,
            gap: 30
        });
        
        glide.mount({ Controls, Autoplay })

    }
    blocks.forEach( initGallery )

    // JavaScript code to show/hide the extra content when "Read more" button is clicked.
    document.querySelectorAll(".quote .quote__body").forEach( quote => {
        const content = quote.querySelector(".content");
        const readMoreButton = quote.querySelector(".read-more-button");
        const readMoreContent = quote.querySelector(".read-more-content");

        if (readMoreButton) {
            readMoreButton.addEventListener("click", function() {
                if (readMoreContent.style.display === "none") {
                    readMoreContent.style.display = "inline";
                    readMoreButton.textContent = "Read less";
                } else {
                    readMoreContent.style.display = "none";
                    readMoreButton.textContent = "Read more";
                }
            });
        }
    });
    
})();

/**
 * Colours / Brands slider Flexi Block
 */
( () => {
    const blocks = document.querySelectorAll( '.block--colours, .block--our-brands-slider, .block--stone-filter' )

    if ( !blocks ) {
        return
    }

    function initGallery( block ) {
        const glide = new Glide( block.querySelector( '.glide' ), {
            type: 'carousel',
            autoplay: 10000,
            perView: 6,
            gap: 30,
            breakpoints: {
                1200: {
                    perView: 4,
                    gap: 20,
                    peek: 50
                },
                900: {
                    perView: 2,
                    gap: 20,
                    peek: 150
                },
                700: {
                    perView: 1,
                    gap: 20,
                    peek: 150
                }
            }
        })

        glide.mount({ Controls, Autoplay, Breakpoints })
    }
    blocks.forEach( initGallery )
})();


/**
 * Announcement Bar
 */
;( () => {
    const blocks = document.querySelectorAll( '.announcement-bar' )

    if ( !blocks.length ) {
        return
    }

    function initAnnouncementBar( block ) {
        if ( ! block.querySelector( '.glide' )) {
            return
        }
        const glide = new Glide( block.querySelector( '.glide' ), {
            type: 'slider',
            autoplay: 8000,
            perView: 1,
            animationDuration: 1000,
        })

        glide.mount({ Controls, Autoplay })

    }
    blocks.forEach( initAnnouncementBar )
})();
